import {
  ILicense,
  ILicenseServices,
  IntegrationStatus,
  LicenseType,
} from '../../../../../models/License'

const types = [
  LicenseType.LICENSE_PREMIUM_ASSISTENT,
  LicenseType.LICENSE_PREMIUM_BASIC,
  LicenseType.LICENSE_PREMIUM_ROOMS,
  LicenseType.LICENSE_PREMIUM_PROFESSIONAL,
]

export default function integrationCount(
  integrations: ILicenseServices,
  licenses: ILicense[],
): number {
  const airbnb = licenses.some((l) => types.includes(l.licenseType))

  const iCalendar =
    integrations.iCalendar.status !== IntegrationStatus.NotPurchased
  const booking = integrations.booking.status !== IntegrationStatus.NotPurchased
  const boxBuy = integrations.boxBuy.status !== IntegrationStatus.NotPurchased

  return Number(iCalendar) + Number(booking) + Number(airbnb) + Number(boxBuy)
}
